import styled, { css } from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';

export const CodeBoxContainer = styled.div`
  position: relative;

  > pre {
    margin: unset;
    background: var(--color-interface-layout-lighter) !important;
    border: 1px solid var(--color-interface-layout-normal) !important;
    border-radius: var(--radius-8);
    padding: var(--spacing-m) var(--spacing-xl) var(--spacing-m)
      var(--spacing-s) !important;

    > code > * {
      font-family: monospace;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
    }
  }

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;

      > * {
        user-select: none;
      }
    `}
`;

export const CodeBoxCopyIcon = styled(TrevorIcon).attrs({ name: 'copy' })`
  position: absolute;
  right: var(--spacing-s);
  bottom: var(--spacing-m);
  color: var(--color-interface-secondary-normal);
  cursor: pointer;
`;
